var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"availability-menu sub-menu"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{ name: 'admin-availabilities', params: {} }}},[_vm._v("Upcoming Availability")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }